<template>
  <div class="w-[32px] flex items-center justify-center h-[32px] rounded-full bg-backgrounds-p4">
    <slot />
  </div>
</template>
